import OmronHeader from "components/OmronHeader";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import OmronFooter from "../../components/OmronFooter";

const ResetCompletePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[
          t("common.label.breadcrumbsResetRequest"),
          t("common.label.breadcrumbsResetComplete"),
        ]}
      />
      <PageMain>
        <InnerDiv>
          <div>
            <ResetTitle>{t("resetPage.label.resetCompleteTitle")}</ResetTitle>
            <Text>{t("resetPage.text.resetComplete")}</Text>

            <Text>
              <LoginLink href="/">
                {t("resetPage.label.loginPageLink")}
              </LoginLink>
            </Text>
          </div>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};
export default ResetCompletePage;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas: "header" "breadc" "main" "footer";
  min-height: 100vh;
`;
const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;

const ResetTitle = styled.h1`
  margin-bottom: 3rem;
  text-align: center;
`;

const LoginLink = styled.a`
  display: inline-block;
  width: 15rem;
  padding: 1.23rem 2rem;
  color: #ffffff;
  background: #005eb8;
  border: 1px #005eb8 solid;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  transition: all 0.3s ease-out;
  :hover {
    background: rgba(0, 94, 184, 0.7);
  }
`;
const Text = styled.p`
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
  text-align: center;
`;
